import { getSessionStorage, setSessionStorage } from 'src/functions/localStorageHandler';

let pageLoadTimestamp = Date.now();
let sessionPageCount = 0;
let utmParams: { source: string | null; medium: string | null; campaign: string | null } = {
  source: null,
  medium: null,
  campaign: null,
};

export const resetPageLoadTimestamp = (): void => {
  pageLoadTimestamp = Date.now();
};

export const incrementSessionPageCount = (): void => {
  sessionPageCount++;
};

export const captureUtmParams = (): void => {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const source = params.get('utm_source');
  const medium = params.get('utm_medium');
  const campaign = params.get('utm_campaign');

  if (source || medium || campaign) {
    utmParams = { source, medium, campaign };
    setSessionStorage('track_utm_source', source || '');
    setSessionStorage('track_utm_medium', medium || '');
    setSessionStorage('track_utm_campaign', campaign || '');
  } else {
    utmParams = {
      source: getSessionStorage('track_utm_source') || null,
      medium: getSessionStorage('track_utm_medium') || null,
      campaign: getSessionStorage('track_utm_campaign') || null,
    };
  }
};

// Active experiment assignments (experimentName → 'control' | 'test')
const activeExperiments: Record<string, string> = {};

export const setExperimentVariant = (experimentName: string, variant: string): void => {
  activeExperiments[experimentName] = variant;
};

export const getActiveExperiments = (): Record<string, string> => ({ ...activeExperiments });

export const resetActiveExperiments = (): void => {
  for (const key of Object.keys(activeExperiments)) {
    delete activeExperiments[key];
  }
};

export const getPageLoadTimestamp = (): number => pageLoadTimestamp;
export const getSessionPageCount = (): number => sessionPageCount;
export const getUtmParams = (): typeof utmParams => utmParams;
